document.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
 const image = document.getElementById('MainProductImage');
 image.src = button.dataset.photo; image.alt = button.dataset.alt;
 document.querySelectorAll('[data-photo]').forEach(b => { b.classList.toggle('selected', b === button); b.setAttribute('aria-pressed', String(b === button)); });
}));
function updatePurchase() {
 const input = document.querySelector('.bundle input:checked');
 const destination = document.getElementById('DeliveryCountry');
 const button = document.querySelector('.add-button');
 if (!input || !button) return;
 const serviceable = !destination || destination.value !== 'OTHER';
 document.querySelectorAll('.bundle').forEach(label => label.classList.toggle('chosen', label.contains(input)));
 button.disabled = !serviceable || input.dataset.available !== 'true';
 button.textContent = !serviceable ? 'Not serviceable in this country' : input.dataset.available !== 'true' ? 'Currently unavailable' : `Buy Now — ${input.dataset.price} ↗`;
 const message = document.getElementById('ServiceMessage');
 if (message) message.textContent = serviceable ? 'Free standard shipping is available.' : 'Sorry, we currently ship only to the US, Canada and UK.';
}


const purchaseForm = document.getElementById('ToeFlexProductForm');
const originalUpdatePurchase = updatePurchase;
updatePurchase = function () {
 originalUpdatePurchase();
 const selected = document.querySelector('.bundle input:checked');
 if (!selected || !purchaseForm) return;
 const variant = purchaseForm.querySelector('[name="id"]');
 if (variant.value !== selected.value) { variant.value = selected.value; variant.dispatchEvent(new Event('change', {bubbles:true})); }
 const disabled = purchaseForm.querySelector('.add-button').disabled;
 purchaseForm.querySelector('[data-add-cart]').disabled = disabled;
 purchaseForm.querySelector('.express-checkout').hidden = disabled;
};
document.querySelectorAll('.bundle input').forEach(input => input.addEventListener('change', () => updatePurchase()));
document.getElementById('DeliveryCountry')?.addEventListener('change', () => updatePurchase());
updatePurchase();
const drawer = document.getElementById('CartDrawer');
const root = document.body.dataset.root || '/';
let cartBusy = false;
function cartStatus(message) { document.getElementById('CartStatus').textContent = message; }
async function cartRequest(path, body) {
 const response = await fetch(root + path, {method:body ? 'POST' : 'GET', headers:body ? {'Content-Type':'application/json','Accept':'application/json'} : {'Accept':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
 const result = await response.json();
 if (!response.ok) throw new Error(result.description || result.message || 'Unable to update cart. Please try again.');
 return result;
}
function cartElement(tag, text, className) { const el = document.createElement(tag); if(text) el.textContent=text; if(className) el.className=className; return el; }
function renderCart(cart) {
 const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency}).format(value/100);
 document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent=cart.item_count);
 const container = document.getElementById('CartItems'); container.replaceChildren();
 cart.items.forEach(item => {
  const row=cartElement('article',null,'drawer-item');
  if(item.image) {const img=cartElement('img'); img.src=item.image; img.alt=item.product_title; img.width=80; img.height=80; row.append(img);}
  const info=cartElement('div'); info.append(cartElement('h3',item.product_title),cartElement('p',item.variant_title),cartElement('strong',money(item.final_line_price)));
  const controls=cartElement('div',null,'drawer-controls');
  const label=cartElement('label','Quantity '); const qty=cartElement('input'); qty.type='number'; qty.min='0'; qty.step='1'; qty.value=item.quantity; qty.setAttribute('aria-label','Quantity for '+item.variant_title);
  qty.addEventListener('change',()=>{if(!qty.validity.valid || qty.value===''){qty.value=item.quantity;return;} changeCart(item.key,Number(qty.value));}); label.append(qty);
  const remove=cartElement('button','Remove'); remove.type='button'; remove.addEventListener('click',()=>changeCart(item.key,0));
  controls.append(label,remove); info.append(controls); row.append(info); container.append(row);
 });
 document.getElementById('CartSummary').hidden=!cart.item_count;
 document.getElementById('CartTotal').textContent=money(cart.total_price);
 cartStatus(cart.item_count ? 'Review your items before checkout.' : 'Your cart is empty. Choose a set to get started.');
}
async function changeCart(id,quantity) {
 if(cartBusy) return; cartBusy=true;
 drawer.querySelectorAll('input,button').forEach(el=>el.disabled=true);
 drawer.querySelector('[data-cart-checkout]').setAttribute('aria-disabled','true');
 cartStatus('Updating cart…');
 try {renderCart(await cartRequest('cart/change.js',{id,quantity}));} catch(error) {cartStatus(error.message);}
 finally {cartBusy=false; drawer.querySelectorAll('input,button').forEach(el=>el.disabled=false); drawer.querySelector('[data-cart-checkout]').removeAttribute('aria-disabled');}
}
async function openCart() {
 if(!drawer.open) drawer.showModal();
 cartStatus('Loading your cart…');
 try {renderCart(await cartRequest('cart.js'));} catch(error) {cartStatus(error.message+' Use View full cart below.');}
}
document.querySelectorAll('[data-open-cart]').forEach(link=>link.addEventListener('click',event=>{if(typeof drawer.showModal !== 'function') return; event.preventDefault();openCart();}));
document.querySelector('[data-close-cart]')?.addEventListener('click',()=>drawer.close());
drawer?.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)drawer.close();}});
drawer?.querySelector('[data-cart-checkout]').addEventListener('click',event=>{if(cartBusy)event.preventDefault();});
purchaseForm?.addEventListener('submit',async event=>{
 if(!event.submitter?.matches('[data-add-cart]')) return;
 event.preventDefault();
 const button=event.submitter; if(button.disabled) return; button.disabled=true;
 const errorBox=document.getElementById('PurchaseError'); errorBox.textContent='';
 try {await cartRequest('cart/add.js',{items:[{id:purchaseForm.querySelector('[name="id"]').value,quantity:1}]});await openCart();}
 catch(error){errorBox.textContent=error.message;}
 finally{updatePurchase();}
});
